export default {"src":"/_next/static/media/location_visits_1.45ae470b.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};